/* eslint-disable */
import MainService from './MainService'
import store from '@/store/index'

import Vue from 'vue'

class locationTracker {
  storage: any = {}
  parentLocation: any = {}

  constructor () {
    this.parentLocation = store.state.parentLocation
    this.storage = store.state.storage
  }

  trackLocation () {
    const trackedLocation = {
      url: `${this.parentLocation.origin}${this.parentLocation.pathname}`,
      title: Vue.prototype.$widget.parentLocation.title
    }

    if (this.storage.room.currentLocation.url === trackedLocation.url || !this.storage.room.session.id) {
      return false
    }

    const data = {
      route: `ocular/urls-history`,
      params: {
        session_id: this.storage.room.session.id,
        page_url: trackedLocation.url,
        page_title: trackedLocation.title
      }
    }

    MainService.post(data)
      .then((response) => {
        const res = response.data

        if (res.statusCode === 0) {
          this.storage.room.currentLocation = trackedLocation
          store.state.storage = this.storage
          Vue.prototype.$storage.updateStorageData()
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {})
  }
}

Vue.prototype.$locationTracking = new locationTracker()
